module.exports = __webpack_public_path__ + "img/aboutUs.f03ca5e1.png";